import { Button, Grid, Box, IconButton, Stack, Typography, TextField as MuiTextField } from '@mui/material';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, dropdownFetch } from '../../../../../utils';
import axios from 'axios';

const TABLE_HEADER = [
  {
    header: 'Test Name',
    accessor: (row) => row?.testData?.test_name
  }
];

export const LabDetailForm = ({ onClose, onAdd, test, sponsorID }) => {
  const [originaltestData, setOriginalTestData] = useState([]);
  const [isFiltered, setIsFiltered] = useState(false);
  const [inputLab, setInputLab] = useState('');
  const [LabpriceListDropdown, setLabPriceListDropdown] = useState([]);
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        test: Yup.string().required('Please select Test')
      })
    ),
    defaultValues: {
      quantity: 1
    },
    mode: 'all'
  });
  const { reset } = methods;

  const { handleSubmit, setValue, watch } = methods;

  const formSubmitHandler = (formValues) => {
    const selectedTest = test.find(({ test_name }) => test_name === formValues.test);
    const testId = selectedTest ? selectedTest._id : '';
    const transformedValues = {
      ...formValues,
      test: testId
    };

    console.log('HELLLO TRANSFORMED VALUES TESTS', transformedValues);

    onAdd(transformedValues);
  };

  const handleServiceSelection = (row) => {
    methods.resetField('test');
    setValue(
      'rate',
      row?.inputValues[0]['NABH Ipd Char'] > 0
        ? row?.inputValues[0]['NABH Ipd Char']
        : row?.inputValues[0]['Ipd Charge'] || 0
    );

    setValue('test', row?.testData?.test_name);
  };

  useEffect(() => {
    if (test && Array.isArray(test) && test.length > 0) {
      setOriginalTestData(test);
      setIsFiltered(false);
    }
  }, [test]);

  const getTestDropdown = useCallback(async () => {
    const response = await axios.get(`${BASE_URL}/lab-price-list-master/list?&sponsorName=${sponsorID}`);
    setLabPriceListDropdown(response.data.data);
  }, [sponsorID]);

  useEffect(() => {
    getTestDropdown();
  }, [sponsorID]);

  useEffect(() => {
    getTestDropdownn(inputLab);
  }, [inputLab]);

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInputLab(newInput);
  };
  const getTestDropdownn = useCallback(async () => {
    const response = await axios.get(
      `${BASE_URL}/lab-price-list-master/list?&sponsorName=${sponsorID}&testName=${inputLab}`
    );
    console.log(response.data.data);
    setLabPriceListDropdown(response.data.data);
  }, [sponsorID, inputLab]);

  return (
    <Stack spacing={1} sx={{ height: '100%' }}>
      <Stack
        padding={1.5}
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor="grey.300"
      >
        <Typography variant="h4" fontWeight="bold">
          Add Billing Details
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>
      <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 2 }}>
        <MuiTextField
          sx={{
            width: '100%',
            '& .MuiOutlinedInput-root': {
              padding: '0'
            },
            '& .MuiOutlinedInput-input': {
              padding: '8px 14px'
            }
          }}
          label="Search Tests"
          variant="outlined"
          value={inputLab}
          onChange={handleChange}
          InputProps={{
            style: {
              fontSize: '12px',
              fontWeight: 600
            }
          }}
        />
      </Stack>
      <FormProvider
        sx={{ height: '100%', overflow: 'auto' }}
        methods={methods}
        onSubmit={handleSubmit(formSubmitHandler)}
      >
        <Grid container spacing={1} sx={{ flex: 1, height: '100%', overflow: 'auto' }}>
          <Grid
            item
            xs={6}
            sx={{
              height: '100%',
              overflow: 'auto',
              display: 'flex',
              flexDirection: 'column',
              gap: 1
            }}
          >
            <Table
              containerSX={{ flex: 1, height: '100%', overflow: 'auto' }}
              size="small"
              sx={{ fontSize: '32px' }}
              data={LabpriceListDropdown || []}
              columns={TABLE_HEADER}
              onRowClick={handleServiceSelection}
            />
          </Grid>
          <Grid item xs={6}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.2, px: 2 }}>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Test Name</Typography>
                <TextField sx={{ flex: 0.8 }} name="test" placeholder="Test Name" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Quantity</Typography>
                <TextField
                  sx={{ flex: 0.8 }}
                  type="number"
                  inputProps={{ min: '0' }}
                  name="quantity"
                  placeholder="Quantity"
                />
              </Stack>

              <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end" marginTop="40%">
                <Button variant="contained" type="submit">
                  Add
                </Button>
                <Button variant="outlined" onClick={onClose} color="error">
                  Close
                </Button>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </FormProvider>
    </Stack>
  );
};
